






















































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import { appFunc_callExit, callAppFunc_navigateFeedBack } from '@/utils/bridge'
import { Toast } from 'vant'
import { getKf } from '@/api/index'
import Clipboard from 'clipboard'
@Component({
  name: 'SecurityCenter',
  components: {}
})
export default class SecurityCenter extends Vue {
  public isshow = false
  created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
    console.log(data, '-------------------', window.location.href)
    const clipboard = new Clipboard('.copy')
    // 成功回调
    clipboard.on('success', e => {
      Toast(this.$t('复制成功'))
      e.clearSelection()
    })
  }
  goFeedbank() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      this.$router.push({
        path: '/problem',
        query: {
          language: this.language
        }
      })
    } else if (/(Android)/i.test(navigator.userAgent)) {
      callAppFunc_navigateFeedBack()
    } else {
      return false
    }
  }
  copy() {
    const copy_text = 'allo2020kyd' //拿到想要复制的值
    if (!navigator.clipboard) {
      const ele = document.createElement('input')
      ele.value = copy_text
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      if (document.execCommand('copy')) {
        Toast(this.$t('复制成功'))
      }
    } else {
      navigator.clipboard.writeText(copy_text).then(() => {
        Toast(this.$t('复制成功'))
      })
    }
  }
  async showPop() {
    // this.isshow = true
    // const res = await getKf()
    // if (res.code == 1001) {
      // window.location.href = res.data.positionThree
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc892f9c8fb7762f36'

    // }
  }
  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  //   跳转至反电信网络诈骗通知
  handleFraud() {
    this.$router.push({
      path: '/fraud',
      query: {
        language: this.language
      }
    })
  }

  //   跳转至平台行为规范
  handleStandard() {
    this.$router.push({
      path: '/standard',
      query: {
        language: this.language
      }
    })
  }

  //   跳转至“清朗”专项行动
  handleSpecial() {
    this.$router.push({
      path: '/special',
      query: {
        language: this.language
      }
    })
  }

  //   跳转至净网行动
  handleNetOperation() {
    this.$router.push({
      path: '/net-operation',
      query: {
        language: this.language
      }
    })
  }

  hanleGuide() {
    this.$router.push({
      path: '/guide',
      query: {
        language: this.language
      }
    })
  }

  //返回
  handelback() {
    appFunc_callExit()
  }
}
